/**
 * 海报/长图「上传图片」(`POST /poster/uploads`)的**前端预检**(2026-09-21 日志体检)。
 *
 * 为什么补这一道:0921 11:36:44 测试机真事 —— `POST /api/v1/poster/uploads` 回 413,
 * referrer 是 `/ai-haibao/detail-long?usage=corp`(长图详情页的参考图/成图上传口)。
 * 那条 413 是**后端业务闸**发的,不是 nginx;但前端这条路**一道预检都没有** ——
 * CanvasIntakeBox / BlockInspector / IntakeFollowupPanel / FreeCreateBody 选完图就直接
 * `posterService.uploadRefImage(f)`,手机高清照常见 12~20MB,必然把整个 multipart
 * 传完(慢、耗流量)再挨一刀。
 *
 * ★数字取自后端那道真闸,不是产品选的:
 *   gscq-api `PosterAiPassthroughService#MAX_UPLOAD_BYTES = 10L * 1024 * 1024`
 *   → ErrorCode `POSTER_UPLOAD_TOO_LARGE`(HTTP 413,message「上传文件超过 10MB」)。
 *   参考图/底图/logo/二维码/模板封面**共用**这一个闸。它远比 nginx(生产 220m / 测试机 100m)紧,
 *   所以它才是这条路的真瓶颈 —— 对齐它,别对齐 nginx。
 *   后端改了这个数,这里要跟着改。
 *
 * ★logo/二维码另有更紧的 2MB 预检(`entities/media-provider/model/usePosterUploads`),
 *   那一道先触发,不受本文件影响。
 */
import { uploadTooLargeMessage } from "@/shared/lib/uploadLimits";

/** 单张图大小上限(MB)。与后端 PosterAiPassthroughService.MAX_UPLOAD_BYTES 同口径。 */
export const POSTER_UPLOAD_MAX_MB = 10;

/** 超大小 → 一句人话(与 413 兜底同一套话术);没超 → null。 */
export function posterUploadSizeError(f: File): string | null {
  if (f.size <= POSTER_UPLOAD_MAX_MB * 1024 * 1024) return null;
  return uploadTooLargeMessage(POSTER_UPLOAD_MAX_MB, f.name);
}
